/**
 * @module searchGtm
 */

/**
 * Search GTM
*/

module.exports = function() {
    function searchGtmInit() {

        const NUM_LETTERS_GA_LOG = 3;
        const KEY_UP_DELAY = 1000;

        const searchInputs = document.querySelectorAll( '.search-input-gtm' );

        searchInputs.forEach( ( searchInput, index ) => {
            searchInput.classList.add( 'gtm-ready' );

            const searchInputForm = searchInput ? searchInput.closest( 'form' ) : null;
            const eventType = searchInput ? ( searchInput.dataset.event || 'search_help' ) : null;

            let searchValue = '';

            function debounce( func, wait ) {
                let timeout;
                return function( ...args ) {
                    clearTimeout( timeout );
                    timeout = setTimeout( () => func.apply( this, args ), wait );
                };
            }

            searchInput.addEventListener( 'keyup', debounce( function( e ) {
                searchValue = e.target.value.trim().toLowerCase();
                if ( eventType && searchValue.length >= NUM_LETTERS_GA_LOG ) {
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push( {
                        event: eventType + '_keyup',
                        search_term: searchValue,
                    } );
                }
            }, KEY_UP_DELAY ) );

            if ( searchInputForm ) {
                searchInputForm.addEventListener( 'submit', function( e ) {

                    searchValue = searchInput.value.trim().toLowerCase();

                    if ( searchValue.length > 0 ) {
                        window.dataLayer = window.dataLayer || [];
                        dataLayer.push( {
                            event: eventType + '_submit',
                            search_term: searchValue,
                        } );
                    }
                } );
            }
        } );
    }

    searchGtmInit();
};
